import { lazy } from 'react';

// project import
import Loadable from '../components/Loadable';
import MinimalLayout from '../layout/MinimalLayout';

// render - login
const AuthLogin = Loadable(lazy(() => import('../pages/authentication/login')));
const AuthForgot = Loadable(lazy(() => import('../pages/authentication/forgot')));
const AuthResetPassword = Loadable(lazy(() => import('../pages/authentication/resetPassword')));
const AuthEmailVerify = Loadable(lazy(() => import('../pages/authentication/verifyEmail')));
// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: '/login',
      element: <AuthLogin />
    },
    {
      path: '/forgot',
      element: <AuthForgot />
    },
    {
      path: '/reset-password',
      element: <AuthResetPassword />
    },
    {
      path: '/email/verify/:id/:hash',
      element: <AuthEmailVerify />
    }
  ]
};

export default LoginRoutes;
